// ReservationSuccessPage.jsx - Rezervasyon başarı sayfası
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Layout from '../components/common/Layout';
import Card from '../components/common/Card';
import Button from '../components/common/Button';

const ReservationSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(10);

  // location.state'den rezervasyon bilgilerini al
  const { pin, message, reservationDetails } = location.state || {};

  useEffect(() => {
    // Eğer state yoksa dashboard'a yönlendir
    if (!pin && !message) {
      navigate('/dashboard');
      return;
    }

    // 10 saniye countdown
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [pin, message, navigate]);

  if (!pin && !message) {
    return null;
  }

  return (
    <Layout>
      <div className="max-w-3xl mx-auto py-12">
        {/* Başarı İkonu */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-green-600 rounded-full mb-4 animate-bounce">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-green-400 mb-2">Rezervasyon Başarılı!</h1>
          <p className="text-gray-300">{message || 'Rezervasyonunuz başarıyla oluşturuldu'}</p>
        </div>

        {/* PIN Kodu */}
        <Card className="mb-6 bg-gradient-to-br from-blue-900/50 to-purple-900/50 border-2 border-blue-500">
          <div className="text-center py-6">
            <h2 className="text-xl font-semibold text-blue-200 mb-4">
              Kapı Giriş Kodunuz
            </h2>
            <div className="bg-gray-900 rounded-lg p-6 mb-4 border-2 border-blue-600">
              <div className="text-6xl font-mono font-bold text-blue-400 tracking-widest">
                {pin}
              </div>
            </div>
            <p className="text-sm text-gray-300 mb-2">
              ⚠️ Bu kodu lütfen not alın veya ekran görüntüsü alın
            </p>
            <p className="text-xs text-gray-400">
              Kodunuzu Dashboard {">"} Rezervasyonlarım bölümünden de görebilirsiniz
            </p>
          </div>
        </Card>

        {/* Rezervasyon Detayları */}
        {reservationDetails && (
          <Card className="mb-6">
            <h3 className="text-lg font-semibold text-blue-200 mb-4">Rezervasyon Detayları</h3>
            <div className="grid grid-cols-2 gap-4 text-sm">
              {reservationDetails.room && (
                <div>
                  <span className="text-gray-300">Oda:</span>
                  <p className="text-gray-100 font-medium">{reservationDetails.room}</p>
                </div>
              )}
              {reservationDetails.date && (
                <div>
                  <span className="text-gray-300">Tarih:</span>
                  <p className="text-gray-100 font-medium">
                    {reservationDetails.date?.toDate ? reservationDetails.date.toDate().toLocaleDateString('tr-TR') : reservationDetails.date}
                  </p>
                </div>
              )}
              {reservationDetails.time && (
                <div>
                  <span className="text-gray-300">Saat:</span>
                  <p className="text-gray-100 font-medium">{reservationDetails.time}</p>
                </div>
              )}
              {reservationDetails.duration && (
                <div>
                  <span className="text-gray-300">Süre:</span>
                  <p className="text-gray-100 font-medium">{reservationDetails.duration} saat</p>
                </div>
              )}
            </div>
          </Card>
        )}

        {/* Bilgilendirme */}
        <Card className="mb-6 bg-yellow-900/20 border-yellow-600">
          <div className="flex items-start">
            <svg className="w-6 h-6 text-yellow-500 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <h4 className="text-yellow-200 font-semibold mb-2">Önemli Bilgiler</h4>
              <ul className="text-sm text-gray-300 space-y-1 list-disc list-inside">
                <li>Dekontunuz admin onayından sonra rezervasyonunuz aktif olacaktır</li>
                <li>Kapı kodu rezervasyon saatinizde aktif olacaktır</li>
                <li>Rezervasyon saatinden 2 saat öncesine kadar iptal edebilirsiniz</li>
              </ul>
            </div>
          </div>
        </Card>

        {/* Butonlar */}
        <div className="flex gap-4">
          <Button
            onClick={() => navigate('/dashboard')}
            className="flex-1 bg-blue-600 hover:bg-blue-500"
          >
            Rezervasyonlarımı Gör
          </Button>
          <Button
            onClick={() => navigate('/reserve')}
            className="flex-1 bg-gray-600 hover:bg-gray-500"
          >
            Yeni Rezervasyon
          </Button>
        </div>

        {/* Countdown */}
        <p className="text-center text-sm text-gray-400 mt-4">
          {countdown} saniye içinde otomatik olarak Dashboard'a yönlendirileceksiniz...
        </p>
      </div>
    </Layout>
  );
};

export default ReservationSuccessPage;
